import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-app bg-grey-50" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "s10_mobile" }
const _hoisted_4 = { class: "custom-upload-st2" }
const _hoisted_5 = { class: "py-6 s20 widget" }
const _hoisted_6 = { class: "secondary-font gap-4 mt-0 mb-5 px-6" }
const _hoisted_7 = { class: "table separator skin1 sm selection" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { colspan: "7" }
const _hoisted_10 = {
  key: 0,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_11 = { class: "selection-item" }
const _hoisted_12 = ["for"]
const _hoisted_13 = ["id", "value", "disabled"]
const _hoisted_14 = { class: "font-black" }
const _hoisted_15 = {
  key: 0,
  style: {"height":"16px","margin-left":"5px","filter":"invert(19%) sepia(93%) saturate(4156%) hue-rotate(355deg) brightness(101%) contrast(105%)"},
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEB0lEQVR4nO2dTahWRRjHf5ofmF+YYooomopIghC4EAwiaeEiF6KgkpsSEj9QFLJNmYIaGNUiDApyVaKibkw3akSWJHEVhEoqlURDUbPMrPQ2MjAnRDrjfc/MnJk55/nBf3PvZZ7n/+d97znvfWbOBUEQBEEQBEEQBMGJfsBS4Bhw1egL4EXzPcEDw4HjgCrRN8DI2E3mTh+gyxLy/WE/ErvZnFnZg5AL6Z8VKvCY+V3c06CvAyOqFGo773cQcqHtsZvOjSeBOxWCvgtMj918TnxWIeRC+ravV2wDObDAIeRC82ObSJ0BwDkPQf8MPBrbTMq87iHkQq/FNpMqY4A/PAb9JzAutqkU+cRjyIU+jm0qNWYC/wYIWq/5dGxzqdAbOBEg5EJdpkbrWRow5EIv0XIGA5dqCPoyMJQW81YNIRfaRkuZBPxVY9B/A1NoIZ/WGHKhA7SM5yKEXGgOLaEv8H3EoH8A+tMC1kUMudBaGs5I4NcEgv4NGEWD+TCBkAt9QEN5CuiuGMpyYFiJlldcs9v01Dg+d3j1vWxZd5nDul82bey1yPFtvtqy9hrHtRfSoPHUeccw1lvWf9Vx7QvAQBrARscgtDZY1n/Dw/p6jawZC9zyEMQWS42tnsZe48mY3R5CUMDblhrveKqxi0yZ5XE8td3z1rEyPUNm9DZbaX0F8JGl1g6PdU7ltv3X5d5W/Y/0hLyMnZ5r2e7Zk0J/Wrvi2fw+S739nmtdM6cMkuddz8YVcNBS71CAevoCmzRTgX8CGD8aaOdpmfSW4WkkTIhXlwK+stS0HSRy0WESZW4gw8psginjZMC6z5MY+qzfmYCGv7XU/i5g3R9TG3utD2hWAWcttX3sp7bpFRLhceBGYLOXLPV/CVz7d2A0CeDzk5myHG0ro44ZpPYYlRkO4ynVgfQt45slCnE7+aC6jdco9DInoFRLdDzW2GtJAuZVzXqh7pAHARcTMK5qlr7wDqkz6M0JmFaRpL3XwhPA7QQMq0jS238n1xH03kgGb5nR2Eaj3Z7mkb7/bOuFZyMZO2/eSQ8y0ZySjdHT7JBPgzkdydQiS1+LI/V02mTinRWRDClggqWv0RH70plEfRqMb4239DYqYl/XTDbeeC+iGfWQ/XGu+/pcpbPxwrSKT4PxfTGcWHKyK9bF0PvY63BkI+q+bVt7gE1Ge8zXVAI64hryvARMqEyks6qEHuH8lIABlYnOVh171XEYXjVMOrOOOZZA4yoz6aMaHXM9gcZVZtL31R1zM4HGVWbS5xc75usEGlcZjrs6ZlUCjavMVOmJv/0Db7dSDdNJl6ez62fRSdj0KGSdlRP9zFtC//6RCyT/6abZ5aqzkf8zIAiCIAiCIAiCIAgCbeIeKS6tsZ2f6DkAAAAASUVORK5CYII=",
  alt: "error--v1"
}
const _hoisted_16 = {
  key: 1,
  style: {"height":"16px","margin-left":"5px","filter":"invert(19%) sepia(93%) saturate(4156%) hue-rotate(130deg) brightness(101%) contrast(105%)"},
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABTklEQVR4nK2VPUoEQRCFv8jYwEBdxauIkeK699BZEwMDb2EkiicwmsC/SwhG/oGZqaCrBrJKS0nZ9EpP/808eDBM17zqqa56DWEsAkPgArgF3pXyfA5UwAIF6AGHwBgwEX4DJ8BSqvgAGCUIm3+UbzZi4tu6o1xx4/yNlNSLNeCrhbhxkgx8NS8pi2ngKzDnJjjuUNwopUlsK7YpzSdw7Xk/1sr8Hkqp+AewrBu99KxvoQPTVrwHPHliTmXxoVB8RcVngZuGuDsC3XMFTAN7kZ2HNjiKJZhSod0CcZvgPhBQO0l2MsWNmmL0kGsnSY64PeQqIbDWJDniwk3Uz1Ns+RF4zhC3gyY4KpwFE+CB60XzHZvdi87HBFY7tOt+050w7ODCqYigr35eUpb1mPgfZoD9xO6SGPH+iQsmFdJm0stnamhvSnmWIZI124o+/AB50KFiqZyaQQAAAABJRU5ErkJggg==",
  alt: "external-verified-check-circle-for-approved-valid-content-basic-bold-tal-revivo"
}
const _hoisted_17 = { class: "font-bold" }
const _hoisted_18 = { class: "font-bold" }
const _hoisted_19 = { class: "flex-right" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "s14_mobile px-3" }
const _hoisted_22 = { class: "s6_mobile px-4" }
const _hoisted_23 = ["disabled"]

import { computed, reactive, ref } from 'vue';
    import axios from 'axios';
    import CarteItemDetailsModal from './@components/CarteItemDetailsModal.vue';
    import { useRouter } from 'vue-router';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CartesFormView',
  setup(__props) {

    const router = useRouter();
    const loading = ref(false);
    const errorMessage = ref('');
    const itemDetailsModalRef = ref<InstanceType<typeof CarteItemDetailsModal> | null>(null);
    const importFile = ref<File | null>(null);
    const importDatas = ref([] as Array<any>);
    const queryParams = reactive({
        pageNumber: 1
    });
    const pagination = reactive({
        total: 0,
        per_page: 5,
        last_page: 1
    });
    const paginatedImportDatas = ref([] as Array<any>);
    const selectedItems = ref([] as any[]);
    const areAllItemsSelected = computed(() => {
        return paginatedImportDatas.value.filter(i => !i.has_errors).length == selectedItems.value.length;
    });

    async function downloadCsv() {
        try {
            loading.value = true;
            const response = await axios.get("/backoffice/cartes/download_excel_template", { responseType: "blob" });
            const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "cartes_template.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Erreur de téléchargement :", error);
            errorMessage.value = "Erreur de téléchargement : " + error;
        } finally {
            loading.value = false;
        }
    }
    async function onCsvImportFileLoaded(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {

            selectedItems.value = [];
            importDatas.value = [];
            paginatedImportDatas.value = [];
            queryParams.pageNumber = 1;
            pagination.total = 0;

            const file = input.files[0];
            await doImportCsvImportFileAction(file);

            pagination.total = importDatas.value.length;
            pagination.last_page = Math.ceil(pagination.total / pagination.per_page);
            onPaginate(queryParams.pageNumber);
            input.value = '';
        }
    }
    async function doImportCsvImportFileAction(csvFile: File) {
        try {
            loading.value = true;
            errorMessage.value = '';
            importFile.value = null;
            importDatas.value = [];

            const formToUpload = new FormData();
            formToUpload.append("import_file", csvFile);
            const response = await axios.post(`/backoffice/cartes/prepare_import_file`, formToUpload);
            importDatas.value = response.data;
            importFile.value = csvFile;
            selectedItems.value = importDatas.value.filter(i => !i.has_errors).map(i => i.data.guid);

        } catch (error: any) {
            errorMessage.value = error;
        } finally {
            loading.value = false;
        }
    }

    function onPaginate(page: number) {
        queryParams.pageNumber = page;
        const start = (page - 1) * pagination.per_page;
        paginatedImportDatas.value =  importDatas.value.slice(start, start + pagination.per_page);
    }

    function handleCheckAll(_event: any) {
        const checked = _event.target.checked;
        if (checked) {
            selectedItems.value = paginatedImportDatas.value.filter(i => !i.has_errors).map(i => i.data.guid);
        } else {
            selectedItems.value = [];
        }
    }

    async function doImportSelectionAction() {
        const selectionDatas = importDatas.value.filter(i => selectedItems.value.includes(i.data.guid)).map(i => i.data);
        if (selectionDatas.length == 0) { return; }

        try {
            loading.value = true;
            errorMessage.value = '';
            await axios.post('/backoffice/cartes/import_file_datas', { import_datas: selectionDatas });
            await router.replace('/app/cartes/list?sort=created_at_desc');
        } catch(error: any) {
            errorMessage.value = error;
        } finally {
            loading.value = false;
        }
    }

    function showItemDetailsModal(dataRow: any) {
        if (itemDetailsModalRef.value) {
            itemDetailsModalRef.value.open(dataRow);
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_custom_pagination = _resolveComponent("custom-pagination")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "s10_mobile" }, [
        _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-2" }, " Importer un lot de carte "),
        _createElementVNode("p", { class: "mb-0" }, "Format de fichier supporté: CSV. Taille max: 50MB.")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_custom_button, {
          loading: loading.value,
          type: "button",
          classesList: 'btn black stroke w-100 flex-center my-2',
          onClick: downloadCsv
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("img", {
              src: "/icons/icon-telecharger.svg",
              class: "btn-icon icon-neutral",
              alt: ""
            }, null, -1),
            _createElementVNode("span", null, "Modèle de fichier EXCEL", -1)
          ]))]),
          _: 1
        }, 8, ["loading"]),
        _createElementVNode("label", {
          for: "file-upload2",
          class: _normalizeClass(["custom-upload", {'active': importFile.value}])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("input", {
              id: "file-upload2",
              name: "file-upload",
              type: "file",
              accept: ".xlsx",
              onChange: onCsvImportFileLoaded
            }, null, 32),
            _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"s4 custom-upload-img\">.XLSX</div><div class=\"s12\"><span id=\"file-upload-title\" class=\"custom-upload-text\">Charger le fichier EXCEL</span> <b class=\"color-danger\">*</b><br><span id=\"file-upload-title\" class=\"custom-upload-text\">Uploader le doc</span></div><div class=\"s4 right\"><img src=\"/icons/icon-upload.svg\" class=\"custom-upload-icon\"></div>", 3))
          ])
        ], 2)
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", _hoisted_6, _toDisplayString(importFile.value ? importFile.value.name : "Veuillez importer un fichier"), 1),
        _createElementVNode("table", _hoisted_7, [
          _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, [
                _createElementVNode("label", {
                  class: "btn-circle",
                  for: "check-list1"
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    name: "check-list",
                    id: "check-list1"
                  })
                ])
              ]),
              _createElementVNode("th"),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-up.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Numéro ")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Date Expiration")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-none.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" Banque")
              ]),
              _createElementVNode("th", null, [
                _createElementVNode("img", {
                  src: "/icons/icon-filter-down.svg",
                  class: "size-xxs mt--1",
                  alt: ""
                }),
                _createTextVNode(" N° de Lot")
              ]),
              _createElementVNode("th", { class: "flex-right" })
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                  _createElementVNode("td", _hoisted_9, [
                    (loading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[4] || (_cache[4] = [
                          _createElementVNode("div", { class: "loader dark" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (!loading.value)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(paginatedImportDatas.value, (dataRow, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: 'row_' + index,
                    class: "text-grey-700 over-effect"
                  }, [
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("label", {
                        class: "btn-circle",
                        for: 'item_check_' + index
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          name: "selectedItems[]",
                          id: 'item_check_' + index,
                          value: dataRow.data.guid,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedItems).value = $event)),
                          disabled: dataRow.has_errors
                        }, null, 8, _hoisted_13), [
                          [_vModelCheckbox, selectedItems.value]
                        ])
                      ], 8, _hoisted_12)
                    ]),
                    _createElementVNode("td", _hoisted_14, [
                      _cache[5] || (_cache[5] = _createElementVNode("img", {
                        src: "/icons/icon-data.svg",
                        class: "size-medium"
                      }, null, -1)),
                      (dataRow.has_errors)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                        : _createCommentVNode("", true),
                      (!dataRow.has_errors)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(dataRow.data.numero), 1),
                    _createElementVNode("td", null, _toDisplayString(dataRow.data.annee_expiration + '-' + dataRow.data.mois_expiration), 1),
                    _cache[7] || (_cache[7] = _createElementVNode("td", { class: "font-bold" }, "Orange Bank", -1)),
                    _createElementVNode("td", _hoisted_18, "Lot " + _toDisplayString(dataRow.data.num_lot), 1),
                    _createElementVNode("td", _hoisted_19, [
                      _createElementVNode("button", {
                        class: "btn white2 collapse-open-table",
                        onClick: ($event: any) => (showItemDetailsModal(dataRow))
                      }, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("img", {
                          src: "/icons/icon-list.svg",
                          class: "btn-icon",
                          alt: ""
                        }, null, -1),
                        _createElementVNode("span", null, "Plus", -1)
                      ]))], 8, _hoisted_20)
                    ])
                  ]))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "clear-both h-15" }, null, -1)),
        _createElementVNode("div", _hoisted_21, [
          (selectedItems.value.length > 0)
            ? (_openBlock(), _createBlock(_component_custom_pagination, {
                key: 0,
                modelValue: queryParams.pageNumber,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((queryParams.pageNumber) = $event)),
                  onPaginate
                ],
                total: pagination.total,
                "per-page": pagination.per_page,
                last_page: pagination.last_page
              }, null, 8, ["modelValue", "total", "per-page", "last_page"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_22, [
          (selectedItems.value.length > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn lg w-100 flex-center my-2",
                disabled: selectedItems.value.length == 0,
                onClick: doImportSelectionAction
              }, [
                _cache[9] || (_cache[9] = _createElementVNode("img", {
                  src: "/icons/icon-telecharger.svg",
                  class: "btn-icon",
                  alt: ""
                }, null, -1)),
                _createElementVNode("span", null, "Importer (" + _toDisplayString(selectedItems.value.length) + ")", 1)
              ], 8, _hoisted_23))
            : _createCommentVNode("", true)
        ])
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "clear-both h-70" }, null, -1))
    ]),
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
    _createVNode(CarteItemDetailsModal, {
      ref_key: "itemDetailsModalRef",
      ref: itemDetailsModalRef
    }, null, 512)
  ]))
}
}

})